import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { IconLoader2 } from "@tabler/icons-react";
interface Props {
  item: CartItemOutputDto;
  isLoading: boolean;
}
export function CartItemPrice(t0) {
  const $ = _c(16);
  const {
    item,
    isLoading
  } = t0;
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IconLoader2 className="animate-spin" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const discountedPrice = item.itemPrice - item.discountAmount;
  if (item.discountAmount > 0) {
    let t1;
    if ($[1] !== item.itemPrice) {
      t1 = CurrencyFormatter.formatUSD(item.itemPrice, true);
      $[1] = item.itemPrice;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== t1) {
      t2 = <span className="block text-muted-foreground line-through leading-none">{t1}</span>;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== discountedPrice) {
      t3 = CurrencyFormatter.formatUSD(discountedPrice, true);
      $[5] = discountedPrice;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t3) {
      t4 = <span className="block">{t3}</span>;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
      t5 = <span className="block text-base font-bold">{t2}{t4}</span>;
      $[9] = t2;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t1;
  if ($[12] !== item.itemPrice) {
    t1 = CurrencyFormatter.formatUSD(item.itemPrice, true);
    $[12] = item.itemPrice;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== t1) {
    t2 = <span className="block text-base font-bold">{t1}</span>;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}